var StoreBrandingType;
(function (StoreBrandingType) {
    StoreBrandingType["CustomDTCStore"] = "CustomDTCStore";
    StoreBrandingType["CustomStore"] = "CustomStore";
    StoreBrandingType["UniversalStore"] = "UniversalStore";
})(StoreBrandingType || (StoreBrandingType = {}));
var SiteBrandingType;
(function (SiteBrandingType) {
    SiteBrandingType["CustomDTCStore"] = "CustomDTCStore";
    SiteBrandingType["CustomStore"] = "CustomStore";
    SiteBrandingType["BrandStore"] = "BrandStore";
    SiteBrandingType["UniversalStore"] = "UniversalStore";
})(SiteBrandingType || (SiteBrandingType = {}));

export { SiteBrandingType, StoreBrandingType };
//# sourceMappingURL=type.js.map
